



import { defineComponent, ref } from "@vue/composition-api";
import providers from "@/lib/api";
import config from "@/config";
import router from "@/router";
import { FormValues } from "@/types";
import EmailNotificationsView from "./components/EmailNotificationsView.vue";

export default defineComponent({
  name: "PageEmailNotificationsSettings",
  components: { EmailNotificationsView },
  setup() {
    const loading = ref(true);
    const token = ref("");
    const values = ref<FormValues>({ incomingMessages: true, goingLive: true });

    const getValues = async () => {
      token.value = await providers.EmailSettingsProvider.generateToken();
      const { settings } = await providers.EmailSettingsProvider.find({ token: token.value });
      values.value = { incomingMessages: settings.unread_messages, goingLive: settings.public_livechat };
    };

    const onSubmit = async (cb: Function) => {
      try {
        const settings = {
          unread_messages: values.value.incomingMessages,
          ...(config.featureGoLive ? { public_livechat: values.value.goingLive } : {}),
        };
        const data = {
          token: token.value,
          settings,
        };
        await providers.EmailSettingsProvider.update({ data });
        await router.back();
      } finally {
        cb();
      }
    };

    getValues().finally(() => (loading.value = false));

    return { loading, values, onSubmit };
  },
});
